module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_6_3.226e7ea9.jpeg";